var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-message-additional-box"},[(_vm.url !== null)?_c('div',{staticClass:"pa-thumbnail-preview",class:_vm.additionalClass},[_c('img',{attrs:{"src":_vm.url}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }